module.exports = __webpack_public_path__ + "img/pimg7.54220641.png";